export default __webpack_public_path__ + "static/media/underConstruction.13e92778.svg";